import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  buttonStyle:{
      color:'#003a4d',
      borderColor: '#003a4d',
      fontSize: 16,
      padding: 20
  }
}));

export default function OutlinedButtons(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Button 
        variant="outlined" 
        className={classes.buttonStyle} 
        onClick={()=>props.onClick()}
      >
        {props.label}
      </Button>
    </div>
  );
}
